import {validateText} from '../mixins/component/validateText';
import {validateNumber} from '../mixins/component/validateNumber';
import {ref, getCurrentInstance, computed} from 'vue';
import {validateCombobox} from '../mixins/component/validateCombobox';
import i18nValidate from '@/i18ns/vi/branch/igov/i18nValidate';
import {useDbOptionStore} from '@/stores/dbOptionStore';

export const useValidateControl = ({props}) => {
  const errorMessage = ref('');
  const wordNotCorrected = ref([]);
  const dbOptionStore = useDbOptionStore();

  // 14.04.2023 BHQUAN TODO: Bản alpha hiện tại thực hiện lưu và đóng form chưa check validate
  // pntoan 2.5.2024 Nếu check chính tả thì cũng là 1 dạng validate
  const isValidate = computed(() => props.rules.length > 0 || props.isCheckSpell);
  // const isValidate = computed(() => false);
  const {proxy} = getCurrentInstance();

  // danh sách các cột và detail theo tài khoản từng cột
  const MapField = proxy.$ms.constant.MapDetailColumn;

  const validate = (inputCol = null) => {
    if (inputCol) {
      props = inputCol;
    }
    // Nếu là editor của grid thì sẽ lấy config từ column
    let rules = [];
    if (proxy._isGridEditor) {
      rules = props.disabledValidate ? [] : props.col.rules;

      // validate MLNS trên các màn hình lập/điều chỉnh dự toán thu/chi
      if (props.propsData.isValidateMLNSPlanBudget) {
        let plan_dboptions = dbOptionStore.state.PlanReceipt;
        let mlns_required_array = [];
        //  Nếu thuộc nhóm Chi thì kiểm tra dboption của Chi và ngược lại
        if (props.dataRow.isExpense) {
          plan_dboptions = dbOptionStore.state.PlanExpense;
        }

        // Kiểm tra Cột hiện tại có nằm trong phạm vi validate MLNS đã cấu hình trong Nghiệp vụ hay không
        if (mlns_required_array.includes(props.col.dataField)) {
          rules = [
            {
              name: 'required',
            },
          ];
        }
      } else {
        let tempDataField = props.col.dataField;

        // nếu cột này là `nhóm mục chi` thì dùng `mục` để validate thay
        // vqphong - 20/10/2023 (bug 50534)
        if (tempDataField === 'budget_expense_group_item_code') {
          tempDataField = 'budget_item_code';
        }
      }
    } else {
      rules = props.rules;
    }
    let message = '';
    if (Array.isArray(rules) && rules.length > 0) {
      for (let index = 0; index < rules.length; index++) {
        const rule = rules[index];
        if (rule) {
          const {name, compareValue, customValidate} = rule;
          const controlValue = props.col?.colIndex == -1 ? null : getValueControl();
          // Nếu có custom validate sẽ lấy theo customvalidate
          if (customValidate && typeof customValidate === 'function') {
            message = customValidate(controlValue, compareValue, getTitleError(), props.dataRow, props);
            if (message) {
              break;
            }
          } else {
            message = handlerRule(name, controlValue, compareValue);
            if (message) {
              break;
            }
          }
        }
      }
    }

    //  NXhung 25.10.2023 Sửa lỗi 51260
    //  Thay đổi vị trí ra ngoài vòng lặp loop qua rules
    //  Thực hiện validate riêng các ô tài khoản ngoài luồng các rules còn lại
    if (proxy._isGridEditor) {
      // Thi công check validate với tài khoản nợ có cho câu thông báo khác
      //ntduong2 26/7/2023
      //bug 22649 23066
      if (props.col.dataField == 'debit_account' || props.col.dataField == 'credit_account') {
        // nếu là TK nợ/có là tài khoản bắt đầu bằng số 0
        if (props.col.dataField == 'debit_account') {
          //Thay đổi thành null mà ô còn lại cũng null
          if (!props.dataRow.debit_account && !props.dataRow.credit_account) {
            message = proxy.$tm('i18nBaseForm.Message.ValidateAccountError');
          }
          if (
            !props.dataRow.debit_account &&
            props.dataRow.credit_account &&
            !props.dataRow.credit_account?.startsWith('0')
          ) {
            //Thay đổi thành null mà tài khoản có đang tồn tại và ko bắt đầu = 0
            message = proxy.$tm('i18nBaseForm.Message.ValidateAccountError');
          } else if (props.dataRow.credit_account?.startsWith('0')) {
            message = '';
          }
        } else {
          //Thay đổi thành null mà ô còn lại cũng null
          if (!props.dataRow.debit_account && !props.dataRow.credit_account) {
            message = proxy.$tm('i18nBaseForm.Message.ValidateAccountError');
          }
          //Thay đổi thành null mà tài khoản nợ đang tồn tại và ko bắt đầu = 0
          if (
            !props.dataRow.credit_account &&
            props.dataRow.debit_account &&
            !props.dataRow.debit_account?.startsWith('0')
          ) {
            message = proxy.$tm('i18nBaseForm.Message.ValidateAccountError');
          } else if (props.dataRow.debit_account?.startsWith('0')) {
            message = '';
          }
        }
      }
    }

    errorMessage.value = message;
    // 14.04.2023 BHQUAN TODO: Bản alpha hiện tại thực hiện lưu và đóng form chưa check validate
    return message;
    // return '';
  };
  /**
   * Xử lý các rule validate
   * @param {*} rule tên rule
   * @param {*} compareValue value
   * @returns
   */
  const handlerRule = (rule, controlValue, compareValue) => {
    let message = '';

    const titleError = getTitleError();
    switch (rule) {
      case 'required':
        if (controlValue === undefined || controlValue === null || controlValue === NaN || controlValue === '') {
          message = i18nValidate.messages[rule](titleError, proxy._isGridEditor);
        }
        break;
      case 'moreThan':
        break;
      case 'lessThan':
        break;
      case 'lessThanAmount':
        if (
          controlValue !== undefined &&
          controlValue !== null &&
          !isNaN(controlValue) &&
          compareValue !== undefined &&
          compareValue !== null &&
          !isNaN(compareValue)
        ) {
          if (parseInt(controlValue) > 0) {
            if (parseInt(controlValue) >= parseInt(compareValue)) {
              message = i18nValidate.messages[rule](titleError);
            }
          } else {
            if (parseInt(controlValue) <= parseInt(compareValue) * -1) {
              message = i18nValidate.messages[rule](titleError);
            }
          }
        }
        break;
      case 'equals':
        break;
      case 'pattern':
        if (!validateText.validateRule(compareValue, controlValue)) {
          message = i18nValidate.messages['email'](titleError);
        }
        break;
      case 'diffierentZero':
        if (!validateNumber.validatediffierentZero(controlValue)) {
          message = i18nValidate.messages['diffierentZero'](titleError);
        }
        break;
      default:
        break;
    }
    // 14.04.2023 BHQUAN TODO: Bản alpha hiện tại thực hiện lưu và đóng form chưa check validate
    return message;
    // return '';
  };

  /**
   * Xử lý validate riêng cho combobox
   */
  const handlerValidateCombobox = () => {
    const {rules} = props;
    let message = '';
    if (Array.isArray(rules) && rules.length > 0) {
      for (let index = 0; index < rules.length; index++) {
        const rule = rules[index];
        if (rule) {
          const {name, compareValue, customValidate} = rule;
          // Nếu có custom validate sẽ lấy theo customvalidate
          const controlValue = getValueControl();
          if (customValidate && typeof customValidate === 'function') {
            message = customValidate(controlValue, compareValue, getTitleError(), props.dataRow, props);
          } else {
            message = validateCombobox.validateRule(name, proxy);
          }
          if (message) {
            break;
          }
        }
      }
    }

    errorMessage.value = message;

    // 14.04.2023 BHQUAN TODO: Bản alpha hiện tại thực hiện lưu và đóng form chưa check validate
    return message;
    // return '';
  };

  const clearValidate = () => {
    errorMessage.value = '';
    wordNotCorrected.value = [];
  };
  /**
   * Lấy value của control (Các control override hàm này)
   * @returns
   */
  const getValueControl = () => {
    return proxy.getValue();
  };

  /**
   * Lấy title của error
   * @returns
   */
  const getTitleError = () => {
    const {title} = props;
    if (proxy._isGridEditor) {
      return props.col.caption;
    }
    return title || getValidateName();
  };

  /**
   * Nếu control không khai báo name để hiển thị thông tin lỗi validate -> up parent find label
   */
  const getValidateName = () => {
    const fn = function (el, c) {
      if (!el || c > 10) {
        return null;
      }

      const labelEl = el.querySelector('label');
      if (labelEl) {
        return (labelEl.innerText || '').replace('*', '');
      }

      return fn(el.parentNode, c + 1);
    };

    return fn(proxy.$el, 0);
  };
  return {
    errorMessage,
    validate,
    handlerValidateCombobox,
    getTitleError,
    clearValidate,
    isValidate,
    wordNotCorrected,
  };
};
